module.exports = __webpack_public_path__ + "img/c3.bfc738da.png";